module.exports = __webpack_public_path__ + "static/media/37.657402f6.jpg";